import { render, staticRenderFns } from "./triggerRuleItem.vue?vue&type=template&id=44fc7ac0&scoped=true&"
import script from "./triggerRuleItem.vue?vue&type=script&lang=ts&"
export * from "./triggerRuleItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fc7ac0",
  null
  
)

export default component.exports